export default {
  state: {
    search: null,
    pageSize: 20,
    order: 'id',
    orderAsc: 1,
    currentPage: 1,
    filterTable: []
  },
  mutations: {
    setFilterTable (state, value) { state.filterTable = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/filters/filter-table.js